<template>
  <div id="openAccount">
    <div class="content_box">
      <div class="inner">
        <RegisterFormContainer :title="$t('openDemoAdditAcc.header')">
          <slot />
        </RegisterFormContainer>
      </div>
    </div>
  </div>
</template>

<script>
import RegisterFormContainer from '@/components/register/registerForms/RegisterFormContainer.vue';

export default {
  components: { RegisterFormContainer },
  name: 'OpenDemoAccountTemplate'
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/openAccount.scss';
</style>
